
    import { asyncSvgLoader } from '@shared/lib';
    import { IconBase } from '@shared/ui';
    import { Spinner } from '@travelata-libs/ui-kit';
    import { useViewport } from '@travelata-libs/utils';
    import {
        computed,
        defineComponent,
        type PropType,
        toRefs,
        unref,
    } from 'vue';
    import { type TSizesInputCommon } from '@ve/components/inputs/common/index';
    import checkBoxIcon from './img/checkbox.svg';
    import checkBoxIconMedium from './img/checkboxMedium.svg';
    import checkBoxDisabled from './img/disabledSvg.svg';

    export default defineComponent({
        components: {
            IconBase,
            Spinner,
            checkBoxIconDisabled: asyncSvgLoader(checkBoxDisabled),
            checkBoxIconSmall: asyncSvgLoader(checkBoxIcon),
            checkBoxIconMedium: asyncSvgLoader(checkBoxIconMedium),
        },
        props: {
            isChecked: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            isDisabledIcon: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: '',
            },
            value: {
                type: [String, Boolean, Number],
                required: true,
            },
            hideOverflowText: {
                type: Boolean,
                default: true,
            },
            isHover: {
                type: Boolean,
                default: false,
            },
            isWhiteSpace: {
                type: Boolean,
                default: true,
            },
            checkBoxSize: {
                type: String as PropType<TSizesInputCommon>,
                default: 'small',
            },
            loading: {
                type: Boolean,
                default: false,
            },
            isAuthOrRegistration: {
                type: Boolean,
                default: false,
            },
            checkboxKey: {
                type: String,
                default: ''
            },
            domId: {
                type: String,
                default: ''
            },
            iconLocked: {
                type: Boolean,
                default: false,
            },
            labelClass: {
                type: String,
                default: '',
            },
        },
        setup(props, { emit }) {
            const { value } = toRefs(props);
            const { isMobile } = useViewport();
            const updateInput = (event: any) => {
                if(props.loading) return;

                emit('change', event);
                emit('selected', { value: unref(value), checked: event.target.checked });
            };
            const iconClassList = computed(() => ({
                'checkbox-item-common__icon-disabled': props.disabled && props.isAuthOrRegistration,
                'checkbox-item-common__icon_hover': props.isHover,
                'checkbox-item-common__icon-small': props.checkBoxSize === 'small',
                'checkbox-item-common__icon-medium': props.checkBoxSize === 'medium',
                'checkbox-item-common-mobile__icon': isMobile.value,
            }));
            const iconSize = computed(() => (props.checkBoxSize === 'medium' ? 20 : 16));

            return {
                updateInput,
                iconClassList,
                iconSize,
                isMobile,
            };
        },
    });
